module.exports = __webpack_public_path__ + "static/media/logo.bd9e2d1d.png";